<script setup lang="ts">
import { provide } from "vue";

import { menuListConfigKey } from "./injectKeys";

const props = defineProps<{ multiselect?: boolean; selectable?: boolean }>();

provide(menuListConfigKey, { multiselect: props.multiselect, selectable: props.selectable });
</script>

<template>
  <div class="menu-list">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.menu-list {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
}
</style>
